import React, { useState, useEffect } from 'react';
import SecuritiesBasic from './SecuritiesBasic';
import { get_securities_fum } from '../../services/common';
import moment from 'moment';

const SecuritiesFum = ({ fumId }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (fumId) {
      getSecuritiesFum();
    }
  }, [fumId]);


  const getTransaction = async () =>{


  }
  const getSecuritiesFum = async () => {
    try {
      // const localData = JSON.parse(localStorage.getItem('caprock-local') || '{}'); // Fixed: Changed variable name
      const userToken = localStorage.getItem('systemToken'); // Fixed: Updated reference
      
      const response = await get_securities_fum(userToken, fumId);
      
      if (response.success === 200) {
        const transactionsData = response.transactions || [];
        
        const processedTransactions = transactionsData.map(trans => ({
          ...trans,
          trans_date: moment(trans.trans_date).format('DD MMM, YYYY'),
        }));

        setTransactions(processedTransactions);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error('Error fetching securities fum:', error);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full px-1 py-3 border-b">
        <div className="flex justify-center items-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
          <span className="ml-2">Loading...</span>
        </div>
      </div>
    );
  }

  if (!fumId) {
    return null;
  }

  return (
    <div className="w-full px-1 py-3 border-b">
      <SecuritiesBasic fumId={fumId} />
      
      <div className="w-full mt-4 px-3">
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '100px' }}>Date</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '150px' }}>Credit</th>
                <th className="border border-gray-300 px-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '150px' }}>Debit</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length > 0 ? (
                transactions.map((trans) => (
                  <tr key={trans.trans_id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_date}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm" style={{ whiteSpace: 'normal' }}>
                      {trans.ref_description}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_type === 2 && typeof trans.trans_amount !== 'undefined' 
                        ? `${trans.currency_symbol} ${trans.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : '-'}
                    </td>
                    <td className="border border-gray-300 px-2 py-1 text-sm whitespace-nowrap">
                      {trans.trans_type === 1 && typeof trans.trans_amount !== 'undefined' 
                        ? `${trans.currency_symbol} ${trans.trans_amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                        : '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="border border-gray-300 px-2 py-1 text-center text-gray-500">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SecuritiesFum;
